import { RECEIVE_CAMPAIGNS, RECEIVE_CURRENT_STORE } from '../actions/types';


export default function campaignsReducer(state, action) {
  switch (action.type) {
    case RECEIVE_CURRENT_STORE:
      return {
        ...state,
        store: action.store,
      };
    case RECEIVE_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.campaigns,
      };
    default:
      return state;
  }
}
